import React, { FunctionComponent, useState } from 'react'

interface NewsItem {
    id:number;
    description:string;
    heading:string;
    selected:boolean
}
interface SearchResponse {
    success: boolean;
    message: string;
    items: NewsItem[]
}
interface Props {
    env: string;
}
const NewsLetterAdminApp: FunctionComponent<Props> = ({env}) => {
    const [searchValue,setSearchValue] = useState("");
    const [language, setLanguage] = useState('sv');
    const [list, setList] = useState<SearchResponse|null>(null);
    const [saveMessage,setSaveMessage] = useState('');
    const searchFunc= async ()=>{
        setList(null);
        setSaveMessage('');
        const response = await fetch('./search/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({query:searchValue,language:language}),
        });

        if (response.ok) {
            const result = await response.json();
            setList(result);
        } else {
            console.error('Error:', response.statusText);
        }
    }
    
    const saveSubscription = async()=>{
        const response = await fetch('./save/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: searchValue,
                language: language,
                items: list?.items
            }),
        });
        if (response.ok) {
            const result = await response.json();
            setList(null);
            setSaveMessage(result.message);
        } else {
            console.error('Error:', response.statusText);
        }
    }
    const toggleSelected = (id: number) => {
        setList(prev => prev && ({
            ...prev,
            items: prev.items.map(item =>
                item.id === id ? { ...item, selected: !item.selected } : item
            ),
        }));
    };
    
    const clearDDS = async () => {
        if (confirm('Do you want to clear dds for testing?')) {
            const response = await fetch('./cleardds/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                }),
            });
            if (response.ok) {
                const result = await response.json();
                setList(null);
                setSaveMessage(result.message);
            } else {
                console.error('Error:', response.statusText);
            }
        }
    };
    return (
        <>
            <h1>Sök prenumerant</h1>
            <input autoComplete="on" 
                   data-oui-component="true" 
                   className="oui-text-input" 
                   type="text" 
                   placeholder="Sök"
                   spellCheck="true" value={searchValue}
                   onChange={(e)=>setSearchValue(e.target.value)}
            />
            <h3>Prenumereringsspråk:</h3>
            <label className="oui-text" >
                <input type="radio" 
                       value="sv" 
                       checked={language==='sv'} 
                       onChange={(e)=> setLanguage(e.target.value)}/>
                Svenska
            </label>
            <label className="oui-text">
                <input type="radio"
                       value="en"
                       checked={language==='en'}
                       onChange={(e)=> setLanguage(e.target.value)}/>
                Engelska
            </label>
            <hr/>
            <button onClick={searchFunc} className="oui-button oui-button--highlight oui-button--default oui-button oui-button--highlight">Sök</button>
            {
                list && !list.success && <div> {list.message}</div>
            }

            { 
                saveMessage && (
                    <div>{saveMessage}</div>
                )
            }
            {
                list && list.success && list.items &&
                (
                    <>
                    <h3>Nyhetsbrev</h3>
                    <ul className="oui">
                        {
                            list.items.map((item)=>(
                                <li ><label className="oui-text"><input type="checkbox" 
                                           className="mdc-checkbox__native-control"
                                           value={item.id} 
                                           checked={item.selected}
                                           onChange={() => toggleSelected(item.id)}
                                />{item.heading}</label><div className="oui-text">{item.description}</div></li>
                            ))
                        }
                    </ul>
                        <button onClick={saveSubscription} className="oui-button oui-button--highlight oui-button--default">Spara</button>
                    </>
                )
            }
            {
                ((env.toLowerCase()==='test') || (env.toLowerCase()==='integration') || (env.toLowerCase()==='staging') || (env.toLowerCase()==='development')) && (
                    <div>
                        <button onClick={clearDDS} className="oui-button oui-button--danger">Clear DDS</button>
                    </div>
                )
            }
        </>
    )
}

export default NewsLetterAdminApp